var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-generator',{staticClass:"ma--top_3xs",attrs:{"form-model":_vm.formModel,"options":_vm.options,"formdata":_vm.innerFormdata}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }